
let initialState = (new Date().getFullYear());

function year(state = initialState, action) {
    if (action.type === "YEAR_INCREMENT") {
        return state + 1;
    } else if(action.type === "YEAR_DECREMENT") {
        return state - 1;
    } else {
        return state;
    }
}
export default year;


// WEBPACK FOOTER //
// ./src/reducers/year.js